// extracted by mini-css-extract-plugin
export var tableContainer = "styles-module--tableContainer--I4e+t";
export var testing = "styles-module--testing--gaQHC";